<template>
    <div class="app-container mt-5">
        <div class="d-flex justify-content-between">
            <div class="page-title mb-3">
                <router-link to="/configuration">
                <span class="breadcrumb-link">
                    <v-icon class="breadcrumb-link-icon">settings</v-icon> Configuration du compte
                </span>
                </router-link>
                <v-icon>keyboard_arrow_right</v-icon>
                <span class="breadcrumb-item">
                <v-icon class="breadcrumb-item-icon">bolt</v-icon> Automatisation Apidae
            </span>
            </div>

            <div class="text-right">
                <v-btn
                  class="default-button"
                  @click="saveAccountApidaeConfig">
                    <v-icon>save</v-icon>
                    Enregistrer
                </v-btn>
            </div>
        </div>

        <div class="row">
            <div class="col-3">
                <v-alert text class="mb-5">
                    En activant cette option, Uska créera automatiquement un brouillon sur Apidae à chaque réponse de
                    prestataire reçue, qu'elle provienne d'une campagne ou d'une demande individuelle. <br>
                    Vous n'aurez plus besoin de rentrer dans chaque nouvelle réponse pour cliquer sur
                    <strong>"Faire une demande de brouillon sur Apidae"</strong>. <br>
                    A chaque réponse reçue, vous recevrez un e-mail vous informant soit: <br>
                    • qu’un brouillon a été créé avec les nouvelles informations,<br>
                    • qu’aucune modification n’a été détectée (aucun brouillon créé), <br>
                    • ou qu’une erreur est survenue lors de l’envoi sur Apidae et qu’une action est requise de votre
                    part. <br>
                    📌 Les brouillons devront toujours être vérifiés et publiés manuellement sur Apidae. <br>
                    Cette option peut être activée ou désactivée à tout moment.
                </v-alert>
            </div>
            <div class="col">
                <v-card class="p-4">
                    <div class="d-flex mb-5">
                        <div class="d-flex justify-content-between w-100">
                            <div>
                                <h5 class="pt-4" v-if="apidaeAutoWrite">
                                    Création automatique des brouillons sur Apidae activée
                                </h5>
                                <h5 class="pt-4" v-else>
                                    Création automatique des brouillons sur Apidae inactive
                                </h5>
                                <span class="mb-3">
                                    Uska crée automatiquement un brouillon sur Apidae à chaque réponse reçue. Vous êtes
                                    informé par e-mail si le brouillon est créé, si aucune modification n'est détectée
                                    ou si une erreur nécessite votre intervention. La publication manuelle du brouillon
                                    sur Apidae sera nécessaire.
                                </span>
                            </div>

                            <v-switch
                              v-model="apidaeAutoWrite"
                              hide-details
                              class="pt-0 mt-0 ml-8 pb-4"
                            ></v-switch>
                        </div>
                    </div>
                </v-card>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex"

export default {
    name: "ApidaeConfig",
    data() {
        return {
            apidaeAutoWrite: "0",
        }
    },
    methods: {
        getAccountApidaeConfig() {
            this.$global.loading = true

            this.$http.get("auth/account/apidae-configuration/" + this.account.id).then(res => {
                this.apidaeAutoWrite = res.body.data.apidaeAutoWrite
                this.$global.loading = false
            })
        },
        saveAccountApidaeConfig() {
            this.$global.loading = true
            let payload = {
                autoApidaeWrite: this.apidaeAutoWrite,
                accountId: this.account.id,
            }

            this.$http.put("auth/account/apidae-configuration", payload).then(res => {
                this.$global.loading = false
            })
        },
    },
    computed: {
        ...mapState("account", [
            "account",
        ]),
    },
    created() {
        this.getAccountApidaeConfig()
    },
}
</script>